import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Bounce } from "react-toastify";

export const RegisterForm = () => {
  const [email, setEmail] = useState("");
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPass, setConfimPass] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    if (email === "") {
      setErrMsg("Please input email!");
    } else if (password === "") {
      setErrMsg("Please input password!");
    } else if (confirmPass === "") {
      setErrMsg("Please input confirm password!");
    } else if (password !== confirmPass) {
      setErrMsg("Does not match password!");
    } else if (userName === "") {
      setErrMsg("Please input userName!");
    } else {
      setErrMsg("");
      axios
        .post("https://api.claimdefenderaigame.com:5000/api/users/signup", {
          email: email,
          password: password,
          userName: userName,
        })
        .then(function (response) {
          switch (response.data.msg) {
            case "duplicate":
              toast.warn("Email already registered!", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                transition: Bounce,
              });
              break;
            case "duplicate Username":
              toast.warn("UserName already used!", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                transition: Bounce,
              });
              break;
            case "success":
              toast.success(
                "Congratulations! You have successfully registered!",
                {
                  position: "top-right",
                  autoClose: 3000,
                  hideProgressBar: false,
                  closeOnClick: false,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "colored",
                  transition: Bounce,
                }
              );

              // const audio = new Audio("/sounds/correct-156911.mp3");
              // audio.play();

              navigate("/");
              break;
            default:
              break;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };

  return (
    <div className="min-h-screen bg-blue-600 flex items-center justify-center p-4 relative">
      <div className="max-w-[950px] p-8 flex gap-6 bg-white rounded-xl">
        <img
          className="w-1/2 rounded-xl object-cover hover:scale-105 transform transition-transform"
          src="/images/va-celebration.jpg"
          alt=""
        />
        <div className="w-1/2 flex flex-col bg-white">
          <div className="flex justify-center mb-4">
            <div className="bg-blue-500 rounded-full w-16 h-16 flex items-center justify-center">
              <span className="text-white text-2xl font-bold">CD</span>
            </div>
          </div>

          <h1 className="text-blue-500 text-2xl font-bold text-center mb-1">
            CLAIM DEFENDER A.I
          </h1>

          <h2 className="text-black font-bold text-center mb-2">
            CLAIM TRACKER
          </h2>

          <p className="text-center text-sm text-blue-500 mb-6">
            Where Easy Hail Claim VA&apos;s fight the evil insurance companies
          </p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="email" className="text-sm text-gray-600">
                User Name
              </label>
              <input
                id="username"
                type="text"
                placeholder="James Bond"
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
                className="w-full border rounded p-2"
              />
            </div>
            <div>
              <label htmlFor="email" className="text-sm text-gray-600">
                Code Name (Email)
              </label>
              <input
                id="email"
                type="email"
                placeholder="manager2@test.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full border rounded p-2"
              />
            </div>

            <div>
              <label htmlFor="password" className="text-sm text-gray-600">
                Secret Password
              </label>
              <input
                id="password"
                type="password"
                placeholder="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full border rounded p-2"
              />
            </div>

            <div>
              <label htmlFor="password" className="text-sm text-gray-600">
                Confirm Password
              </label>
              <input
                id="password"
                type="password"
                placeholder="password"
                value={confirmPass}
                onChange={(e) => setConfimPass(e.target.value)}
                className="w-full border rounded p-2"
              />
            </div>

            <button
              type="submit"
              className="relative w-full bg-blue-500 hover:bg-blue-600 text-white py-2 rounded"
            >
              <p className="text-red-600 text-xs text-center absolute -top-4 transform left-1/2 -translate-x-1/2">
                {errMsg}
              </p>
              Accept Mission
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};
